import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { UpdateMealDateEntity } from '../../domain/entities/UpdateMealDateEntity'

export class UpdateMealDateModel extends UpdateMealDateEntity {
  declare startAt: string
  declare lockAt: string
  declare companyPeriodTime: string
  constructor(dataDto: UpdateMealDateEntity) {
    super()
    mapEntityProperties<UpdateMealDateEntity>(this, dataDto)
  }
}
